<template>
  <button class="btn-sns btn-sns--s" @click="onClick" />
</template>

<script>
export default {
  methods: {
    onClick() {
      this.$emit('click-sns-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns {
  @extend %hover-common;

  &--s {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-position: center;
    cursor: pointer;
  }
}
</style>
